<template>
  <fieldset :disabled="$attrs.disabled">
    <div>
      <!-- Campaign Name -->
      <text-input
        id="campaign-name"
        name="Name"
        placeholder="Name"
        rules="max:200|required"
        :text.sync="campaign.name"
      />
      <!-- Subject -->
      <text-input
        id="campaign-subject"
        name="Subject"
        placeholder="You’re invited to [First Upcoming event title] (Start date time)"
        rules="required|max:400"
        :text.sync="campaign.subject"
      />
      <!-- From -->
      <text-input
        id="campaign-from"
        name="Organizer Name"
        placeholder="From"
        rules="required|max:200"
        :text.sync="campaign.from"
      />
      <!-- Header Image -->
      <profile-picture-uploader
        file-type="campaign_header"
        label="Header Image"
        description="Recommended image size: 2160 x 1080px - Maximum file size: 10MB - supported image files: JPEG or PNG"
        :disabled="$attrs.disabled"
        :image.sync="campaign.header"
      />

      <!-- Email Body -->
      <rich-text-editor
        name="Email Body"
        rules="required|max:5000"
        :description.sync="campaign.body"
        :disabled="$attrs.disabled"
      />
      <!-- Events Select -->
      <event-select
        multiple
        :disabled="$attrs.disabled"
        :filter="{status:2}"
        :event.sync="campaign.events"
        :selectable="() => campaignEventsCount < 3"
      />
    </div>
  </fieldset>
</template>

<script>
import EventSelect from '../Events/EventSelect.vue'
import RichTextEditor from '../FormInputs/RichTextEditor.vue'
import TextInput from '../FormInputs/TextInput.vue'
import ProfilePictureUploader from '../FormInputs/ProfilePictureUploader.vue'

export default {
  name: 'CampaignInputs',
  components: {
    TextInput,
    RichTextEditor,
    EventSelect,
    ProfilePictureUploader,
  },
  props: {
    campaign: { type: Object, default: () => {} },
  },
  computed: {
    campaignEventsCount() {
      return this.campaign.events?.length || 0
    },
  },
}
</script>

<style>

</style>
